import { Link } from 'react-router-dom';

export default function Unauthorized() {
	return (
		<div className="flex items-center justify-center min-h-screen bg-gray-100">
			<div className="text-center">
				<h1 className="text-3xl font-bold text-red-500">403 - Acceso Denegado</h1>
				<p className="text-gray-700 mt-4">No tienes permisos para acceder a esta página.</p>
				<Link to="/" className="text-blue-500 underline mt-4 inline-block">
					Volver al inicio
				</Link>
			</div>
		</div>
	);
}
